




















































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import OpenIncidentModal from "../OpenIncidentModal.vue";
import FullScreenModal from "../../shared/modal/FullScreenModal.vue";
import ProformaModal from "./ProformaModal.vue";
import AttachmentsModal from "./AttachmentsModal.vue";
import { AlertBus } from "../../../plugins/alerts/AlertBus";
import {
  ShipmentDTO,
  PickupDTO,
  ManagePickupRequestDTO,
  DocumentDTO
} from "../../../model/data.model";
import {
  ShipmentListItem,
  ShipmentManagementDef
} from "../../../model/component.model";
import { ShipmentService } from "../../../services/ShipmentService";
import { EventBus } from "../../../event-bus";
import i18n from "../../../lang/i18n";
import router from "../../../router/router";
import store from "../../../vuex/store";
import { isGermany, popupFileBase64 } from "@/services/Helpers";
import { formatToTimeZone } from "date-fns-timezone";
import { canShowIncidentButton } from "@/helpers/useIncidentButton";

@Component({
  components: {
    MbeFullScreenModal: FullScreenModal,
    MbeProformaModal: ProformaModal,
    MbeAttachmentsModal: AttachmentsModal,
    OpenIncidentModal
  }
})
export default class NewShipmentToolbar extends Vue {
  @Prop() selectedItems: ShipmentListItem[];
  @Prop() selectedTab: string;

  modalProformaVisible = false;
  shipmentProformaLoaded = false;
  shipmentProforma: ShipmentDTO = {} as ShipmentDTO;
  loadShipment() {
    ShipmentService.getShipment(this.selectedItems[0].shipmentId).then(res => {
      this.shipmentProforma = res;
      this.shipmentProformaLoaded = true;
      this.modalProformaVisible = true;
    });
  }

  modalAttachmentsVisible = false;

  modalProformaOptions = {
    classicon: "invoice-image",
    title: i18n.t("proforma"),
    closeDisabled: true
  };

  modalAttachmentOptions = {
    classicon: "invoice-image",
    title: i18n.t("attachments"),
    closeDisabled: true
  };

  showOpenIncidentModal = false;

  get germany() {
    return isGermany();
  }

  get isDev() {
    return this.$store.getters.envs.isDev;
  }

  get isPrintWaybillButtonEnabled() {
    return (
      this.$store.getters["customer/config"].canPrintWaybill &&
      this.selectedItems.some(
        (shipment: ShipmentListItem) =>
          shipment.status === "CREATED" ||
          shipment.status === "DRAFT_WAYBILL" ||
          shipment.status === "INVOICED"
      )
    );
  }

  get isPrintMergedWaybillsButtonEnabled() {
    return (
      this.isPrintWaybillButtonEnabled &&
      this.$store.getters["customer/config"].canMergeWaybills
    );
  }

  selectedItemsCount() {
    return this.selectedItems.length;
  }

  selectedItemStatus() {
    return this.selectedItems[0].status;
  }

  selectedShipmentId() {
    return this.selectedItems[0].shipmentId;
  }

  anySelectedItemHasStatusDifferentFromDraftToBeClosed() {
    for (let i = 0; i < this.selectedItemsCount(); i++) {
      if (this.selectedItems[i].status != "DRAFT_TO_BE_CLOSED") {
        return true;
      }
    }
    return false;
  }

  handlePODClick() {
    const options = { timeZone: store.getters.timeZoneId };
    const shipments = this.selectedItems.map((el: any) => {
      let value =
        el.shipmentPackages[0] && el.shipmentPackages[0].trackingDate
          ? el.shipmentPackages[0].trackingDate
          : el.deliveredDate;
      value = value
        ? formatToTimeZone(new Date(value), "", options).split(".")[0] + "Z"
        : "";
      return {
        shipmentId: el.shipmentId,
        deliveredDate: value !== "" ? new Date(value).getTime() : ""
      };
    });
    ShipmentService.prototype.getPODFiles(shipments).then(res => {
      const printTitle = String(i18n.t("POD"));
      res.forEach((doc: DocumentDTO) => {
        popupFileBase64(doc.contentDocument, "PDF", `${printTitle}.pdf`, this);
      });
    });
  }
  handlePODClickAsync() {
    const options = { timeZone: store.getters.timeZoneId };
    const shipments = this.selectedItems.map((el: any) => {
      let value =
        el.shipmentPackages[0] && el.shipmentPackages[0].trackingDate
          ? el.shipmentPackages[0].trackingDate
          : el.deliveredDate;
      value = value
        ? formatToTimeZone(new Date(value), "", options).split(".")[0] + "Z"
        : "";
      return {
        shipmentId: el.shipmentId,
        deliveredDate: value !== "" ? new Date(value).getTime() : ""
      };
    });
    ShipmentService.prototype.getPODFilesAsync(shipments).then(res => {
      this.$notify.success(String(this.$t("generating_POD")));
    });
  }

  confirmShipmentClosure(action: string = null) {
    AlertBus.$alerts
      .confirm(i18n.t("confirm_shipment_closure"))
      .then((val: boolean) => {
        if (val) {
          this.$emit(
            "doShipmentClosure",
            action ?? "PRINT_SIMPLIFIED_MANIFEST"
          );
        }
      });
  }

  selectedItemsNotFromSameCourier() {
    const [head, ...tail] = this.selectedItems;
    return tail.reduce(
      (acc, item) => acc || item.courierName !== head.courierName,
      false
    );
  }

  selectedItemCanNotBeDeleted() {
    const canDeleteShipments = this.$store.getters["customer/config"]
      .canDeleteShipments;
    const canPrintWaybill = this.$store.getters["customer/config"]
      .canPrintWaybill;
    const deletableAll = this.selectedItems.some((s: any) => {
      let deletable =
        s.status === "DRAFT_TO_BE_CLOSED" ||
        s.status === "FIRST_DRAFT_TO_BE_CLOSED";

      if (!deletable) {
        deletable =
          canDeleteShipments &&
          canPrintWaybill &&
          (this.selectedItems[0].status === "CREATED" ||
            this.selectedItems[0].status === "DRAFT_WAYBILL");
      }
      return !deletable;
    });

    return deletableAll;
  }

  get disableProformaButton(): boolean {
    if (this.selectedItemsCount() === 1) {
      return (
        !(
          this.selectedItems[0]?.proforma?.totalValue &&
          this.selectedItems[0].proforma.totalValue > 0
        ) ||
        (this.$store.getters["customer/config"].hideStoreProforma &&
          this.selectedItems[0].proforma.createdByStore)
      );
    } else {
      return true;
    }
  }
  hideManifests() {
    if (
      this.selectedTab !== "shipment_status_pending_closure" &&
      this.selectedTab !== "shipment_status_draft"
    ) {
      return true;
    } else {
      return false;
    }
  }

  disableManifests() {
    for (let i = 0; i < this.selectedItemsCount(); i++) {
      if (
        this.selectedItems[i].status === "DRAFT_TO_BE_CLOSED" ||
        this.selectedItems[i].status === "FIRST_DRAFT_TO_BE_CLOSED"
      ) {
        return true;
      }
    }
    return false;
  }

  openPaperlessDocument() {
    this.$emit("openPaperlessDocument");
  }

  openIncidentModal() {
    this.showOpenIncidentModal = true;
  }

  get showIncidentButton() {
    return (
      canShowIncidentButton(this.selectedTab, this.selectedItems) &&
      this.$store.getters["customer/claimConfig"].canOpenIncidents
    );
  }

  incidentOpened() {
    this.$notify.success(String(this.$t("incident_opened")));
    this.showOpenIncidentModal = false;
  }

  get checkPaperlessDocument() {
    return !!(
      this.selectedItems.length == 1 &&
      (this.selectedItems[0].paperlessDocumentIds
        ? this.selectedItems[0].paperlessDocumentIds.length
        : false) &&
      !this.$store.getters["customer/config"].disablePaperlessFeature
    );
  }
}
